import React, { useEffect, useReducer } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import MyDatePicker from '../input/MyDatePicker'
import ErrorBoundary from '../ErrorBoundary'
import moment from 'moment'
import 'moment/locale/ja'
moment.locale('ja')

const stateReducer = (state, action) => {
  if (action.type === 'setDate') {
    return { ...state, date: action.value }
  } else if (action.type === 'setSalesMonth') {
    const isValid = /\d\d\d\d-\d\d/.test(action.value)
    const minDate = isValid ? moment(action.value + '-01') : moment('1900-01-01')
    const dateRange = {
      minDate: minDate.format('YYYY-MM-DD'),
      maxDate: isValid ? minDate.endOf('month').format('YYYY-MM-DD') : '9999-12-31'
    }
    /*
      日付のルール：
      - dateRangeの外→売上月が今月なら今日、そうでないならdateRangeの1日
      - dateRangeの内→元の値
    */
    const date = (state.date.isAfter(dateRange.maxDate) || state.date.isBefore(dateRange.minDate))
      ? (minDate.format('YYYY-MM') === moment().format('YYYY-MM') ? moment() : moment(dateRange.minDate))
      : state.date
    return { date: date, salesMonth: action.value, dateRange: dateRange }
  } else {
    return state
  }
}

export default function CoopTrdDtPicker (props) {
  const defaultValue = moment(props.value).isValid() ? moment(props.value) : null
  const [state, dispatch] = useReducer(
    stateReducer,
    { date: defaultValue ?? moment(), salesMonth: '', dateRange: { minDate: '1900-01-01', maxDate: '9999-12-31' } }
  )

  useEffect(() => {
    // 最初だけ実行
    const salesMonthElem = $('input[name="sales_month"]')
    salesMonthElem.on('change', (e) => {
      dispatch({ type: 'setSalesMonth', value: e.target.value })
    })
    salesMonthElem.trigger('change')
  }, [])

  const getHelperText = (_date, _salesMonth) => {
    const momentYearMonth = props.yearMonth !== ''
      ? moment(`${props.yearMonth.substr(0, 4)}-${props.yearMonth.substr(4, 2)}-01`)
      : null
    if (_date && momentYearMonth?.isAfter(_date)) {
      return '処理月より前の日付が設定されているため、このままでは最終承認できません。'
    } else if (
      !props.readOnly &&
      defaultValue &&
      _date &&
      defaultValue.format('YYYY-MM-DD') !== _date.format('YYYY-MM-DD')
    ) {
      return `現在設定されている日付は${defaultValue.format('YYYY-MM-DD')}です。`
    } else {
      return ''
    }
  }

  const helperText = getHelperText(state.date, state.salesMonth)

  return (
    <div className="my-input-root">
      <MyDatePicker
        id={props.id}
        name={props.name}
        label={props.label}
        value={state.date.format('YYYY-MM-DD')}
        onChange={(date) => dispatch({ type: 'setDate', value: moment(date) })}
        readOnly={props.readOnly}
        required={true}
        error={helperText.length > 0}
        helperText={helperText}
        minDate={state.dateRange.minDate}
        maxDate={state.dateRange.maxDate}
      >
      </MyDatePicker>
    </div>
  )
}

CoopTrdDtPicker.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  yearMonth: PropTypes.string
}

CoopTrdDtPicker.defaultProps = {
}

$('.coop-trd-dt-picker').each((i, elem) => {
  const props = $(elem).data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  props.yearMonth = props.yearMonth?.toString() ?? ''
  ReactDOM.render(
    <ErrorBoundary>
      <CoopTrdDtPicker {...props}/>
    </ErrorBoundary>,
    elem
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    $(elem).removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
